import { render, staticRenderFns } from "./TicketByAssignee.vue?vue&type=template&id=d35e5962&scoped=true&"
import script from "./TicketByAssignee.vue?vue&type=script&lang=js&"
export * from "./TicketByAssignee.vue?vue&type=script&lang=js&"
import style0 from "./TicketByAssignee.vue?vue&type=style&index=0&id=d35e5962&lang=scss&scoped=true&"
import style1 from "./TicketByAssignee.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35e5962",
  null
  
)

export default component.exports